import Service, { getCallApiFunction } from '../service'
import { TPreference } from '@/types/preference-tag'

export type ParamsType = {
  preferenceTagList: Array<TPreference['preferenceTag']>
}

class SetMemberPreferenceTagApi extends Service {
  constructor({ preferenceTagList }: ParamsType) {
    super()
    this.name = 'SET_MEMBER_PREFERENCE_TAG'

    this.config = {
      url: `/v1/livemall/preferences`,
      method: 'PATCH',
      data: {
        tagList: preferenceTagList,
      },
    }
  }
}

export const setMemberPreferenceTag = (params: ParamsType) => getCallApiFunction(new SetMemberPreferenceTagApi(params))
